module.exports = __webpack_public_path__ + "static/media/medication.6d670859.png";